<template>
  <div class="page imag">
    <div class="top">
      <div>
        <div class="icon"></div>
        <div class="title"><span>Habblet Imager</span></div>
      </div>
    </div>
    <div class="content">
      <div class='centraliza'>
        <div class='esquerda'>
          <div class='titulo'>Habblet:</div>
          <input id="usuario" placeholder="Vaguinho" name="user" type="text" v-model="nick" @change="imager()">

          <div class='clearfix'></div>

          <div class='titulo'>Rosto:</div>
          <select id="rosto" name="rosto" v-model="rosto" @change="imager()">
            <option value="std">Normal</option>
            <option value="spk">Falando</option>
            <option value="sml">Sorrindo</option>
            <option value="srp">Surpreso</option>
            <option value="agr">Nervoso</option>
            <option value="sad">Triste</option>
            <option value="lol">Sem Rosto</option>
          </select>

          <div class='clearfix'></div>

          <div class='titulo'>Ação:</div>
          <select id="acao" name="acao" v-model="acao" @change="imager()">
            <option value="std">Normal</option>
            <option value="wlk">Andando</option>
            <option value="wlk,wav">Andando/Acenando</option>
            <option value="sit">Sentado</option>
            <option value="sit,wav">Sentado/Acenando</option>
            <option value="lay">Deitado</option>
            <option value="wav">Acenando</option>
          </select>

          <div class='clearfix'></div>

          <div class='titulo'>Objeto:</div>
          <select id="objeto" name="objeto" v-model="item" @change="imager()">
            <option value="">Nenhum</option>
            <option value="0">Nada (Objeto imaginário)</option>
            <option value="6">Água</option>
            <option value="44">Bebida Tóxica</option>
            <option value="1">Café</option>
            <option value="2">Cenoura</option>
            <option value="42">Chá Japonês</option>
            <option value="667">Coquetel</option>
            <option value="5">Habblet Refri</option>
            <option value="9">Poção do Amor</option>
            <option value="3">Sorvete</option>
            <option value="33">Sorvete (Callipo)</option>
            <option value="43">Suco de Tomate</option>
          </select>

          <div id="bb" :class="{active: item !== ''}">
            <input type="checkbox" name="bbcc" id="bbcc" value=",drk=" v-model="seg" @change="imager()">
            <div class='titulo' style='width: 215px; line-height: 30px; text-align: left; float: right;'>
              Bebendo/Comendo
            </div>
          </div>

          <div class='clearfix'></div>

          <div class='titulo'>Tamanho:</div>

          <div class='tamanhos' style='width: 165px; margin-bottom: 17px;'>
            <label>
              <input type="radio" name="tamanho" id="tamanho" value="s" v-model="tamanho" @change="imager()">
            </label>
            <label>
              <input type="radio" checked name="tamanho" id="tamanho" value="b" v-model="tamanho" @change="imager()">
            </label>
            <label>
              <input type="radio" name="tamanho" id="tamanho" value="l" v-model="tamanho" @change="imager()">
            </label>

            <div class='clearfix'></div>
            <div class='titulo tmais'>Pequeno</div>
            <div class='titulo tmais'>Médio</div>
            <div class='titulo tmais'>Grande</div>
          </div>
          <div class='clearfix'></div>

          <div class='titulo'>URL:</div>
          <input type="text" id="url_img" :value="url">
        </div>

        <div class='direita'>

          <div class='clearfix'></div>
          <div class='fundo-user'>
            <a id="img_link" target="_blank" :href="url">
              <div class="avatar">
                <img alt="" :src="url" @change="imager()" id="img">
              </div>
            </a>
          </div>
          <div class='menu-girar' style='padding: 14px 10px; margin-top: 5px;'>
            <div class='so-cabeca'></div>
            <input type="checkbox" name="cabeca" id="cabeca" value="1" style='margin-left: 5px;' v-model="soH"
                   @change="imager()">
          </div>
          <div class='menu-girar'>
            <div class='girar'>
              <div id="h_l" class='seta-box' @click="imager(dirH + 1, dir)" @change="imager()"><i
                class='fa fa-angle-left'></i></div>
              <div class='cabeca'></div>
              <div id="h_r" class='seta-box' @click="imager(dirH - 1, dir)" @change="imager()"><i
                class='fa fa-angle-right'></i></div>
            </div>

            <div class='clearfix'></div>
            <div class='girar'>
              <div id="b_l" class='seta-box' @click="imager(dirH, dir + 1)" @change="imager()"><i
                class='fa fa-angle-left'></i></div>
              <div class='corpo'></div>
              <div id="b_r" class='seta-box' @click="imager(dirH, dir - 1)" @change="imager()"><i
                class='fa fa-angle-right'></i></div>
            </div>
          </div>

          <select id="formato" class='formato' name="formato">
            <option value="png">PNG</option>
            <option value="gif">GIF</option>
          </select>

          <div class='clearfix'></div>
        </div>
      </div>
      <span class="credits">Gerador de Habblet Imager feito por Marco cruel.<br>JavaScript modificado para o VueJS por ZiniiBr</span>
    </div>
  </div>
</template>

<script setup>

import { ref } from 'vue'
import { IMAGER } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'

const dir = ref(4)
const dirH = ref(4)
const nick = ref('Zinii')
const item = ref('')
const acao = ref('std')
const tamanho = ref('b')
const rosto = ref('std')
const action = ref('')
const soH = ref(false)
const formato = ref('')
const seg = ref(false)
const frame = ref(30)
const effect = ref('')
const dance = ref('')
const url = ref(IMAGER + '?user=zinii&action=std&direction=4&head_direction=4&img_format=png&gesture=std&headonly=0&size=b')
let imagerUseTracked = false

async function imager(direH = 4, dire = 4) {

  if (seg.value) {
    action.value = acao.value + ',drk=' + item.value
  } else {
    action.value = acao.value + ',crr=' + item.value
  }

  if (direH < 7) dirH.value = direH
  if (direH > 0) {
    dirH.value = direH
  } else {
    dirH.value = 0
  }
  if (dire < 7) dir.value = dire
  if (dire > 0) {
    dir.value = dire
  } else {
    dir.value = 0
  }
  url.value = `${IMAGER}?user=${nick.value}&action=${action.value}&gesture=${rosto.value}&direction=${dir.value}&head_direction=${dirH.value}&headonly=${soH.value}&size=${tamanho.value}&img_format=${formato.value}&dance=${dance.value}&effect=${effect.value}&frame_num=${frame.value}`

  if (!imagerUseTracked && nick.value.trim().length >= 3) {
    imagerUseTracked = true
    trackEvent('imager_use')
  }
}

imager()
</script>

<style scoped>
.imag .top .icon {
  background-color: #21415C;
  background-position: -3px -96px;
}

.clearfix {
  clear: both;
}

:focus {
  outline: 0;
}

.centraliza {
  width: 590px;
  height: 270px;
  position: relative;
  top: 50%;
  margin-top: 10px;
  left: 50%;
  margin-left: -295px;
  image-rendering: pixelated;
}

.centraliza input, select {
  background-color: transparent;
  width: 200px;
  height: 30px;
  padding: 0 10px;
  margin: 5px;
  border: none;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  color: #999;
  -webkit-appearance: none;
  font-family: 'Ubuntu', sans-serif;
}

.centraliza input[type="text"] {
  width: 180px;
}

.centraliza select {
  background-image: url(https://1.bp.blogspot.com/-Lrc_o4XSWN4/VwsMr_2sf3I/AAAAAAAAAyk/yJaqrrqDOkooUiu-EOqt6Exx4eFu_4fXw/s1600/seta.png);
  background-repeat: no-repeat;
  background-position: 176px center;
  overflow: hidden;
  position: relative;
}

.centraliza input[type="radio"],
.centraliza input[type="checkbox"] {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  cursor: pointer;
  display: inline-block;
  margin-left: 27px;
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.centraliza input[type="checkbox"] {
  border-radius: 2px;
  padding: 0 5px;
}

.centraliza input[type="radio"]:after,
.centraliza input[type="checkbox"]:after {
  width: 12px;
  height: 12px;
  border-radius: 10px;
  content: '';
  display: block;
  top: 4px;
  left: -1px;
  position: relative;
}

.centraliza input[type="checkbox"]:after {
  border-radius: 1px;
}

.centraliza input[type="radio"]:checked:after, .centraliza input[type="checkbox"]:checked:after {
  background-color: #999;
}

.tamanhos input[type="radio"] {
  margin-left: 16px;
  margin-right: 11px;
  width: 15px;
  height: 15px;
  padding: 0 5px;
}

.tamanhos input[type="radio"]:after {
  width: 7px;
  height: 7px;
}

.esquerda {
  width: 280px;
  position: relative;
  float: left;
}

.direita {
  width: 315px;
  position: relative;
  float: left;
  margin-left: -10px;
}

.titulo {
  width: 60px;
  line-height: 40px;
  color: #999;
  float: left;
  text-align: center;
  font-size: 16px;
}

.tmais {
  width: 46px;
  line-height: 10px;
  font-size: 10px;
  text-align: center;
  margin-bottom: 9px;
}

.tamanhos {
  width: 185px;
  float: right;
  margin: 6px 8px;
}

.fundo-user {
  background-position: center;
  width: 200px;
  height: 220px;
  float: left;
  margin: 5px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.avatar {
  width: 200px;
  height: 220px;
  position: relative;
}

.avatar img {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 20px;
}

.menu-girar {
  padding: 10px;
  width: 80px;
  float: right;
  border-radius: 2px;
  margin: 5px 0;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  text-align: center;
  font-size: 14px;
  color: #999;
}

.girar {
  width: 80px;
  height: 25px;
}

.seta-box {
  width: 15px;
  height: 26px;
  padding: 3px 5px 7px;
  float: left;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
  transition: all 0.15s;
  color: #9F9F9F;
}

.seta-box:hover {
  background-color: rgba(0, 0, 0, 0.15);
  color: #FFF;
}

.girar .cabeca {
  background-image: url(https://1.bp.blogspot.com/-WsBLUqV4J3E/VslIiBgiuaI/AAAAAAAAEaY/wL3J5J7orFE/s1600/cabeca.png);
  background-repeat: no-repeat;
  background-position: center;
  width: 30px;
  height: 25px;
  margin-bottom: 10px;
  float: left;
}

.girar .corpo {
  background-image: url(https://4.bp.blogspot.com/-rjclYO-iAHo/VslIiMDDQLI/AAAAAAAAEac/fyZLZ8y10TI/s1600/corpo.png);
  background-repeat: no-repeat;
  background-position: center;
  width: 30px;
  height: 25px;
  float: left;
}

.formato {
  background-position: 76px center;
  width: 100px;
  margin-right: 0;
}

.so-cabeca {
  background-image: url(https://4.bp.blogspot.com/-MqlEG2UdvEw/VzsRBhGEvvI/AAAAAAAAFKA/BH6MiiZzT14xlT4756a0wsezwvMkYPTawCLcB/s1600/so-cabeca.png);
  width: 14px;
  height: 19px;
  float: left;
  margin-left: 15px;
  margin-top: 6px;
  margin-right: -5px;
}

#bb {
  display: none;
}

#bb.active {
  display: block;
}

.credits {
  width: auto;
  height: auto;
  float: right;
  font-size: 13px;
  font-weight: 300;
  opacity: .7;
  font-style: italic;
}

</style>
